import React, { useContext, useState } from 'react'
import { Alert } from 'components'
import { AutoComplete, Button } from 'components/Form'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { CreateBatteryStyles } from './Style'
import { assignAssessmentsToBatteryFetch } from 'store/middlewares/assessment.crud'
import { AssessmentsContext } from './AssessmentsContext'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { keys, map, pickBy } from 'lodash'

const CreateBatteryAlert = (props) => {
    const { handleAlert = () => { } } = props
    const { setResetRowSelection, selectedAssessments, setSelectedAssessments } = useContext(AssessmentsContext)
    const queryClient = useQueryClient()
    const batteries = queryClient.getQueryData([qc.batteries])

    const [battery, setBattery] = useState(null)

    const { mutateAsync: assignAssessmentsToBattery, isPending } = useMutation({
        mutationFn: assignAssessmentsToBatteryFetch,
        onSuccess: () => {
            handleAlert(false)
            setResetRowSelection(true)
            setSelectedAssessments(null)
            queryClient.invalidateQueries([qc.studentBatteries])
            toast("השיוך בוצע בהצלחה", toastConfig)
        }
    })

    const handleCreateBattery = () => {
        const assessments = keys(pickBy(selectedAssessments, v => v === true));
        assignAssessmentsToBattery({ battery: battery.id, assessments })
    }

    return (
        <Alert
            systemUI
            title={"שיוך מבדקים לסוללה"}
            footerActions={[]}
            handleAlert={() => handleAlert(false)}
            closeOnClick
        >
            <CreateBatteryStyles>
                <div className='select-battery'>
                    <AutoComplete
                        input={{
                            value: battery,
                            onChange: setBattery
                        }}
                        placeholder="בחר סוללה"
                        options={batteries}
                        labelKey="label"
                    />
                </div>
                <div>
                    {"נא וודאי שכל המבדקים שבחרת שייכים לאותו תלמיד"}
                    {", בוצעו באותה יחידת לימוד, שייכים לאותו סמסטר ושנת ביצוע"}
                </div>
                <div>
                    <Button
                        loading={isPending}
                        disabled={!battery || isPending}
                        action={handleCreateBattery}
                        color="thirdly"
                        label="שייך מבדקים"
                    />
                </div>
            </CreateBatteryStyles>
        </Alert>
    )
}

export default CreateBatteryAlert